(function () {
    'use strict';

    angular.module('ib-pmt-summary-module', [
        'ib-pmt-dcc-module',
        'ib-pmt-summary-allianz-fusion-secures-module',
        'ib-pmt-summary-bundle-module',
        'ib-pmt-summary-carbon-footprint-module',
        'ib-pmt-summary-globick-activities-module',
        'ib-pmt-summary-globick-transfers-module',
        'ib-pmt-summary-cv-ancillaries-module',
        'ib-pmt-summary-disccounts-module',
        'ib-pmt-summary-extra-baggage-module',
        'ib-pmt-summary-other-module',
        'ib-pmt-summary-passenger-module',
        'ib-pmt-summary-priority-boarding-module',
        'ib-pmt-summary-seats-module',
        'ib-pmt-summary-secures-module',
        'ib-pmt-summary-speqs-module',
        'ib-pmt-summary-trip-module',
        'ib-pmt-summary-type-payment-module',
        'ib-pmt-summary-upgrading-bids-module',
        'ib-summary-item'
    ]);
})();
